module.exports = __webpack_public_path__ + "img/20b)(Mercatorhalle in Duisburg).jpg";